import React, { useEffect, useState } from "react";
import { Table, Modal, Button, Checkbox, Space } from "antd";
import { useGlobal } from "../../global/user";
import { User } from "../../api";
import FixTableContainer from "../FixTableContainer";

export default function UserFieldModal({ userID, visible, setVisible }) {
  const [userFields, setUserFields] = useState([]);
  const [loading, setLoading] = useState(true);
  const { fields } = useGlobal();
  useEffect(() => {
    setLoading(true);
    (async () => {
      if (!userID || userID === -1) return;
      let response = await User.GetUserFields(userID);
      setUserFields(response.data.map((field) => parseInt(field.field_id, 10)));
      setLoading(false);
    })();
  }, [userID]);
  const columes = [
    {
      title: "場域名稱",
      dataIndex: "field_name",
    },
    {
      title: "場域權限",
      align: "center",
      width: 120,
      render: (field) => (
        <Checkbox
          checked={userFields.includes(field.field_id)}
          onClick={async () => {
            await User.SetUserField(userID, field.field_id);
            if (userFields.includes(field.field_id)) setUserFields((data) => data.filter((id) => id !== field.field_id));
            else setUserFields((data) => [...data, field.field_id]);
          }}
        >
          可使用
        </Checkbox>
      ),
    },
  ];

  return (
    <Modal
      title="場域權限設定"
      width={800}
      open={visible}
      onCancel={() => setVisible(false)}
      footer={[
        <Button onClick={() => setVisible(false)} key="back-button">
          返回
        </Button>,
      ]}
    >
      <Table dataSource={fields} columns={columes} loading={loading} />
    </Modal>
  );
}
